<template>
  <b-table
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    :fields="fields"
    :items="items"
    stacked="md"
    show-empty
    responsive
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <div class="flex">
        <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
          <b-dropdown-item @click="editar(item.item)" v-if="podeEditar">
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </template>
  </b-table>
</template>
<script>
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      fields: [
        {
          key: 'siglaDescricao',
          label: this.$t('GERAL.SIGLA'),
          sortable: true,
        },
        {
          key: 'descricao',
          label: this.$t('GERAL.NOME'),
          sortable: true,
        },
        {
          key: 'limiteAvaliacao',
          label: 'Quantidade máxima de lançamentos',
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
    };
  },
  methods: {
    editar(item) {
      this.$emit('editar', 'tipoAvaliacao', item);
    },
    excluir(item) {
      this.$emit('excluir', item);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
